import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NCheckout } from './df-checkout.config';

export const providers = (config?: DeepPartial<NCheckout.IModuleOptions>) => [
    {
        provide: NCheckout.OPTIONS,
        useFactory: () => {
            return defaultsDeep(config, NCheckout.DEFAULT_OPTIONS);
        }
    }
];

export function provideDfCheckout(config?: DeepPartial<NCheckout.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders(providers(config));
}
